var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCuttingEdgeMusicTestingTestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#142533"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.75 59.6562H69.8125V69.8125H65.75V59.6562Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.625 49.5H61.6875V69.8125H57.625V49.5Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3435 69.8125C36.6509 69.8093 34.0694 68.7383 32.1655 66.8343C30.2615 64.9303 29.1904 62.3489 29.1873 59.6563H33.2498C33.2498 60.8615 33.6071 62.0396 34.2767 63.0418C34.9463 64.0439 35.898 64.8249 37.0115 65.2861C38.125 65.7474 39.3503 65.868 40.5323 65.6329C41.7144 65.3978 42.8002 64.8174 43.6524 63.9652C44.5047 63.113 45.085 62.0272 45.3202 60.8451C45.5553 59.663 45.4346 58.4378 44.9734 57.3243C44.5122 56.2108 43.7311 55.2591 42.729 54.5895C41.7269 53.9199 40.5487 53.5625 39.3435 53.5625V49.5C42.0371 49.5 44.6204 50.57 46.5251 52.4747C48.4297 54.3794 49.4998 56.9626 49.4998 59.6563C49.4998 62.3499 48.4297 64.9331 46.5251 66.8378C44.6204 68.7425 42.0371 69.8125 39.3435 69.8125Z",
    fill: "#F2F2F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8745 21.0625H25.1245C24.0474 21.0636 23.0147 21.4919 22.2531 22.2536C21.4914 23.0152 21.0631 24.0479 21.062 25.125V73.875C21.0632 74.9521 21.4917 75.9847 22.2533 76.7463C23.0149 77.5079 24.0474 77.9363 25.1245 77.9375H73.8745C74.9515 77.936 75.984 77.5076 76.7455 76.746C77.5071 75.9845 77.9356 74.952 77.937 73.875V25.125C77.9358 24.0479 77.5074 23.0153 76.7458 22.2537C75.9842 21.4921 74.9516 21.0637 73.8745 21.0625ZM73.8745 39.3437H45.437V25.125H73.8745V39.3437ZM41.3745 25.125V39.3437H25.1245V25.125H41.3745ZM25.1245 73.875V43.4062H73.8759L73.8786 73.875H25.1245Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuttingEdgeMusicTestingTestIcon);
export default __webpack_public_path__ + "static/media/CuttingEdgeMusicTestingTestIcon.34d3fd237477f4cb342457dd9ea6f380.svg";
export { ForwardRef as ReactComponent };